import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class InactivityService {

  private inactivityTimeLimit = 120 * 60 * 1000; // 120 minutes in milliseconds
  private inactivityTimer: any;

  constructor(private navController: NavController) {
    this.initializeInactivityTracking();
  }

  initializeInactivityTracking() {
    // List of events to track
    const events = ['mousemove', 'keydown', 'click', 'touchstart'];

    events.forEach((event) => {
      window.addEventListener(event, () => this.resetTimer());
    });

    // Start the inactivity timer
    this.resetTimer();
  }

  resetTimer() {
    // Clear existing timer
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }

    // Set the timer again
    this.inactivityTimer = setTimeout(() => {
      this.handleInactivity();
    }, this.inactivityTimeLimit);
  }

  handleInactivity() {
    // Handle user inactivity - log out or close the session
    console.log('User is inactive for 120 minutes');
    this.logoutUser();
  }

  logoutUser() {
    // Perform any required logout action
    // For example, clear tokens, redirect to login page, etc.
    this.navController.navigateRoot(['/login']); // Navigate to the login page
    localStorage.removeItem('logged');
  }
}
